import { createContext } from 'react'

export const NotifContext = createContext({
  token: null,
  saveToken: () => { }
})